import type { ProgressState } from "./progress-state";
import { isArenaBackgroundId } from "../config/arena-background-config";

export type ArenaBackgroundSelectionStatus =
  "already-selected" | "invalid-background" | "selected" | "stale-command";

export interface ArenaBackgroundTransition {
  readonly state: ProgressState;
  readonly status: ArenaBackgroundSelectionStatus;
}

export const selectArenaBackground = (
  state: ProgressState,
  id: string,
  expectedSelectedId: string,
): ArenaBackgroundTransition => {
  if (!isArenaBackgroundId(id)) {
    return { state, status: "invalid-background" };
  }
  if (state.selectedArenaBackgroundId === id) {
    return { state, status: "already-selected" };
  }
  if (state.selectedArenaBackgroundId !== expectedSelectedId) {
    return { state, status: "stale-command" };
  }
  return {
    state: { ...state, selectedArenaBackgroundId: id },
    status: "selected",
  };
};
